'use client';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ProductCarousel from '../product/ProductCarousel';
import { useRef } from 'react';
import { useEffect } from 'react';
import { Navigation, Autoplay } from 'swiper/modules';

export default function ProductsSlider({ limit, products, title }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const swiperInstance = swiperRef.current;
    prevRef.current.addEventListener('click', () => {
      swiperInstance.swiper.slidePrev();
    });

    nextRef.current.addEventListener('click', () => {
      swiperInstance.swiper.slideNext();
    });
  }, []);

  return (
    <div className="mt-4 relative">
      <div className="carousel-head py-4  my-4  text-center relative text-center ">
        <h2 className=" text-gray-900 relative px-3 z-10 bg-white md:text-xl font-bold inline-block  lg:max-w-none">
          {title}
        </h2>
      </div>

      <Swiper
        ref={swiperRef}
        slidesPerView="auto"
        spaceBetween={18}
        modules={[Navigation, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={1500}
        loop="true"
      >
        {products.length > 0 ? (
          products.map((product, key) => {
            return (
              <SwiperSlide
                key={key}
                style={{
                  width: 'auto',
                  alignSelf: 'stretch',
                  height: 'auto',
                }}
              >
                <ProductCarousel product={product} limit={limit} />
              </SwiperSlide>
            );
          })
        ) : (
          <div className="w-full">
            <p className="text-center block"> نتیجه‌ای یافت نشد!</p>
          </div>
        )}
      </Swiper>
      <div className="flex justify-between mt-4 rounded-md absolute w-full top-1/2 left-0 right-0 z-10">
        <div
          ref={prevRef}
          className="bg-white px-3 py-2 rounded-md  cursor-pointer shadow-sm"
        >
          {/* Custom Previous Arrow Icon */}
          <CaretLeft className="rotate-180" />
        </div>
        <div
          ref={nextRef}
          className="bg-white px-3 py-2 rounded-md cursor-pointer shadow-sm"
        >
          {/* Custom Next Arrow Icon */}
          <CaretLeft />
        </div>
      </div>
    </div>
  );
}
